import { useState, useEffect } from "react";
import { CustomtOption } from "@utils/customization";

interface UsePdpUIStateProps {
  mediaSectionLayout: any;
  priceMode: number;
}

export const usePdpUIState = ({
  mediaSectionLayout,
  priceMode,
}: UsePdpUIStateProps) => {
  const [addToJewelryMenu, setAddToJewelryMenu] = useState(false);
  const [selectedTabSlideSheet, setSelectedTabSlideSheet] = useState("memo");
  const [customOptions, setCustomOptions] = useState<CustomtOption[]>([]);
  const [itemQuantity, setItemQuantity] = useState(1);

  // Filter custom options based on media section layout and price mode
  useEffect(() => {
    if (
      mediaSectionLayout?.sub_section &&
      typeof mediaSectionLayout.sub_section === "object"
    ) {
      const subSections = Object.values(mediaSectionLayout.sub_section);

      const filteredOptions = subSections
        .filter(
          (subSection) =>
            Array.isArray(subSection.price_modes) &&
            subSection.price_modes.includes(priceMode)
        )
        .sort((a, b) => (a.order || 0) - (b.order || 0));

      setCustomOptions(filteredOptions);
    } else {
      setCustomOptions([]);
    }
  }, [mediaSectionLayout, priceMode]);

  return {
    addToJewelryMenu,
    setAddToJewelryMenu,
    selectedTabSlideSheet,
    setSelectedTabSlideSheet,
    customOptions,
    setCustomOptions,
    itemQuantity,
    setItemQuantity,
  };
};
